import type { ButtonHTMLAttributes } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";

import { Icon } from "../../../icon";
import styles from "../../list-toolbar.module.scss";
import type { ListToolbarSearchViewModel } from "./types-search";

type SearchClearButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** O `IconField` do Prime injeta a prop em todo filho; aqui ela não pode chegar ao DOM. */
  iconPosition?: string;
};

function SearchClearButton({ iconPosition: _iconPosition, ...rest }: SearchClearButtonProps) {
  return (
    <button type="button" {...rest}>
      <Icon name="times" size={14} />
    </button>
  );
}

export function ListToolbarSearchView({
  draft,
  placeholder,
  maxLength,
  showClear,
  clearLabel,
  onClear,
  ariaLabel,
  testId,
  clearTestId,
  className,
  style,
  dataWidth,
  dataSize,
  rest,
  onInput,
}: ListToolbarSearchViewModel) {
  return (
    <IconField
      iconPosition="right"
      className={classNames(styles.search, className)}
      style={style}
      data-width={dataWidth}
      data-size={dataSize}
      {...rest}
    >
      <InputText
        type="search"
        maxLength={maxLength}
        value={draft}
        placeholder={placeholder}
        aria-label={ariaLabel}
        onChange={onInput}
        data-testid={testId}
      />
      {showClear ? (
        // O X ocupa o lugar da lupa; limpa só o texto (os demais critérios da tela ficam).
        <SearchClearButton
          className={styles.searchClear}
          aria-label={clearLabel}
          onClick={onClear}
          data-testid={clearTestId}
        />
      ) : (
        <InputIcon>
          <Icon name="search" size={14} />
        </InputIcon>
      )}
    </IconField>
  );
}
